export default __webpack_public_path__ + "static/media/telesaleshelp-summary-mobile.e0184b05.PNG";